import RuleGroup, {RuleGroupLikeObject} from "./RuleGroup";

declare global {
    interface Window {
        MHP_Forms: {
            [key: string]: {
                [key: string]: RuleGroupLikeObject
            }
        }
    }
}

export type Conditions = Map<string, RuleGroup>

export default class Form {
    constructor(
        public readonly key: string,
        public readonly conditions: Conditions
    ) {
    }

    static fromObject(item: {
        key: string,
        conditions: {
            [key: string]: RuleGroupLikeObject
        }
    }): Form {
        const conditions: Conditions = new Map
        for (let key in item.conditions) {
            conditions.set(key, RuleGroup.fromObject(item.conditions[key]))
        }

        return new Form(item.key, conditions)
    }
}
